import React from 'react';
import HtmlHead from "../src/components/headerAndFooter/HtmlHead";
import TextArea from "../src/components/textArea/TextArea";
import WaveLayout from '../src/layouts/WaweLayout';
import {NavigationURLs} from "../src/functions/NavigationFunctions";
import GeneralBreadcrumb from "../src/components/breadcrumb/GeneralBreadcrumbComp";

const CallCenterLighting = () => {
    const breadcrumbItems = [
        { label: 'Pembe Panjur', link: NavigationURLs.landing },
        { label: 'Kişisel Verilerin Korunması'}
    ];
    return (
        <React.Fragment>
            <HtmlHead
                pageTitle="Çağrı Merkezi Aydınlatma Metni | Pembe Panjur"
                description="Pembe Panjur çağrı merkezi aydınlatma metni ile ilgili detaylara sayfamızdan ulaşabilirsiniz."
            />
            <WaveLayout bodyBackgroundColor={false} backgroundColor={'unset'} loginButtonText={false}
                        hamburgerMenuType={'black'} registerButton={true}>
                <TextArea
                    className={'mobile-plr0'}
                >
                    <GeneralBreadcrumb items={breadcrumbItems} margin={false} colorProps={false}/>
                    <h1 className={'mobile-h2-style'}>
                        Kişisel Verilerin Korunması
                    </h1>
                    <h2 className={'desktop-mt-0'}>
                        Çağrı Merkezi Aydınlatma Metni
                    </h2>
                    <p>
                        <span style={{fontWeight: 'bold'}}>Panjur Bilişim ve Danışmanlık Hizmetleri Ticaret A.Ş. (Panjur Bilişim),</span> veri
                        sorumlusu <span style={{fontWeight: 'bold'}}>olarak
                        6698 sayılı Kişisel Verilerin Korunması Kanunu (KVKK) ve ilgili diğer mevzuata uygun olarak
                        kişisel verilerinizi işlemektedir.</span>
                    </p>
                    <p>
                        <span style={{fontWeight: 'bold'}}>
                            KVKK'nın Aydınlatma Yükümlülüğü'nü düzenleyen 10'ncu maddesine göre veri sorumluları, kişisel
                            verilerini işledikleri ilgili kişileri belirli konularda bilgilendirmekle yükümlüdür.
                        </span>
                    </p>
                    <p>
                        <span style={{fontWeight: 'bold'}}>
                            Siz de Panjur Bilişim’e çağrı merkezi vasıtasıyla ulaştığınızdan, işlediğimiz kişisel
                            verileriniz kapsamında “ilgili kişi” olarak nitelendirilmektesiniz.
                        </span>
                    </p>
                    <p>
                        <span style={{fontWeight: 'bold'}}>
                            Öncelikle kişisel verileriniz, çağrı merkezimiz vasıtasıyla otomatik ve kısmen otomatik
                            yöntemlerle elde edilmektedir.
                        </span>
                    </p>
                    <p>
                        <span style={{fontWeight: 'bold'}}>
                            Çağrı merkezimiz yolu ile iletişime geçmeniz sebebiyle işlenen
                        </span>
                    </p>

                    <p>
                        Ad, soyad, talep, telefon numarası ve ses kaydı bilgileriniz;
                    </p>

                    <ul>
                        <li>
                            <span style={{fontWeight: 'bold'}}>
                                İletişim Faaliyetlerinin Yürütülmesi,
                            </span>
                        </li>
                        <li>
                            <span style={{fontWeight: 'bold'}}>
                                Müşteri İlişkileri Yönetim Süreçlerinin Yönetilmesi,
                            </span>
                        </li>
                        <li>
                            <span style={{fontWeight: 'bold'}}>
                                Saklama ve Arşiv Faaliyetlerinin Yürütülmesi,
                            </span>
                        </li>
                        <li>
                            <span style={{fontWeight: 'bold'}}>
                                Talep / Şikayetlerin Takibi
                            </span>
                        </li>
                    </ul>
                    <p>
                        <span style={{fontWeight: 'bold'}}>
                            Amaçlarıyla, KVKK’nın 5. Maddesinde öngörülen
                        </span>
                    </p>
                    <ul>
                        <li>
                            <span style={{fontWeight: 'bold'}}>
                                Bir hakkın tesisi, kullanılması veya korunması için veri işlemenin zorunlu olması ve
                            </span>
                        </li>
                        <li>
                            <span style={{fontWeight: 'bold'}}>
                                İlgili kişinin temel hak ve özgürlüklerine zarar vermemek kaydıyla, veri sorumlusunun meşru
                                menfaatleri için veri işlenmesinin zorunlu olması
                            </span>
                        </li>
                    </ul>
                    <p>
                        <span style={{fontWeight: 'bold'}}>
                            Sebepleriyle işlenmektedir.
                        </span>
                    </p>
                    <p>
                        Kişisel verileriniz KVKK’nın 28. Maddesi çerçevesinde talep edilmesi halinde ilgili makamlara
                        aktarılabilir.
                    </p>
                    <p>
                        Bunun dışında öngörülemeyen durumlarda da kişisel verileriniz kanunlarda açıkça belirtilmiş
                        durumlarda talep edilmesi halinde kanunlarda belirtilen kamu kurumlarına (bakanlıklar gibi idari
                        makamlara) kanunda öngörülen amaç ve sınırlamalar dâhilinde aktarılabilir.
                    </p>
                    <h3 style={{marginTop: 0}}>
                        Kişisel Verilerinizle İlgili Haklarınız
                    </h3>
                    <p>
                        İlgili kişiler kişisel verilerine ilişkin haklarını kullanmak için öncelikle veri sorumlusuna
                        başvurmak zorundadırlar. Kanunun 14'üncü maddesine göre Kişisel Verileri Koruma Kurulu'na
                        doğrudan şikâyette bulunulamaz.
                    </p>
                    <p>
                        Kanun uyarınca kişisel verilerinizle ilgili
                    </p>
                    <ul>
                        <li>
                            Kişisel veri işlenip işlenmediğini öğrenme,
                        </li>
                        <li>
                            Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme,
                        </li>
                        <li>
                            Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını
                            öğrenme,
                        </li>
                        <li>
                            Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme,
                        </li>
                        <li>
                            Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini
                            isteme,
                        </li>
                        <li>
                            İşlenmesini gerektiren sebeplerin ortadan kalkması hâlinde kişisel verilerinizin silinmesini
                            veya yok edilmesini isteme,
                        </li>
                        <li>
                            (d) ve (e) bentleri uyarınca yapılan işlemlerin, kişisel verilerinizin aktarıldığı üçüncü
                            kişilere bildirilmesini isteme,
                        </li>
                        <li>
                            İşlenen verilerinizin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle
                            aleyhinize bir sonucun ortaya çıkmasına itiraz etme,
                        </li>
                        <li>
                            Kişisel verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın
                            giderilmesini talep etme
                        </li>
                    </ul>

                    <p>
                        Haklarınızı veri sorumlusuna yani bize başvurarak kullanabilirsiniz.
                    </p>
                    <p>
                        Başvurunuzu
                    </p>
                    <ul>
                        <li>
                            <span style={{fontWeight: 'bold'}}>Yeşilköy Mah. Atatürk Cad. No: 12/2 EGS Business Park B3 Blok Ofis 264 Bakırköy, İstanbul</span>
                            adresine yazılı olarak;
                        </li>
                        <li>
                            <a href="mailto:panjur.bilisim@hs02.kep.tr"
                               style={{color: '#000', fontWeight: 'bold'}}>panjur.bilisim@hs02.kep.tr</a> kayıtlı
                            elektronik posta adresine kayıtlı elektronik posta
                            adresinizi kullanarak;
                        </li>
                        <li>
                            Sistemimizde kayıtlı bulunan elektronik posta adresinizi kullanarak
                            <a href="mailto:kvk@pembepanjur.com"
                               style={{color: '#000', fontWeight: 'bold'}}> kvk@pembepanjur.com
                            </a> adresine e-posta göndererek gerçekleştirebilirsiniz.
                        </li>
                    </ul>
                    <p>
                        Başvuru yapılırken uyulması gereken usul ve esaslar hakkındaki daha detaylı bilgiye Kişisel
                        Verileri Koruma Kurumu'nun Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında Tebliğ'den
                        ulaşabilirsiniz.
                    </p>
                </TextArea>
            </WaveLayout>
        </React.Fragment>
    )
}

import { checkAuthAndRedirect } from '../src/utils/authHelper';

export const getServerSideProps = async (context: any) => {
    return await checkAuthAndRedirect(context);
};


export default CallCenterLighting;
